module.exports = __webpack_public_path__ + "img/Check.1fc8d12b.svg";